export default {"src":"/_next/static/media/topCurved_bg_mobile.94eade79.svg","height":433,"width":375};